// Stili condivisi dei controlli, come da DESIGN.md

// Focus da tastiera: Rosso FPC pieno con 2px di distacco (contrasto 5,5:1 sul bianco)
export const FOCUS_RING = 'focus:outline-none focus-visible:ring-2 focus-visible:ring-fpcred focus-visible:ring-offset-2';

// Campi: angoli 12px, bordo 2px che diventa Rosso FPC al focus (Errore se non valido).
// 16px su mobile: sotto i 16px Safari iOS ingrandisce la pagina quando si tocca il campo
export const fieldClass = (invalid = false) =>
  `w-full rounded-xl border-2 ${
    invalid ? 'border-red-500 focus:border-red-600' : 'border-gray-300 focus:border-fpcred'
  } bg-white px-4 h-11 md:h-10 text-base md:text-sm text-gray-700 transition-colors duration-300 focus:outline-none`;
